/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Seo_For_Whom_TitleInputs */

const en_seo_for_whom_title = /** @type {(inputs: Seo_For_Whom_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`For trainers, studios and clubs`)
};

const pl_seo_for_whom_title = /** @type {(inputs: Seo_For_Whom_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dla trenerów, studiów i klubów`)
};

/**
* | output |
* | --- |
* | "For trainers, studios and clubs" |
*
* @param {Seo_For_Whom_TitleInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const seo_for_whom_title = /** @type {((inputs?: Seo_For_Whom_TitleInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seo_For_Whom_TitleInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_seo_for_whom_title(inputs)
	return en_seo_for_whom_title(inputs)
});